import { css } from "@vitality-ds/system";
export default css({
  color: "inherit",
  fontSize: "$input",
  lineHeight: "$input",
  overflow: "hidden",
  textOverflow: "ellipsis"
});